import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { Link, useNavigate, useParams } from "react-router-dom";
import Header from "../layouts/Header";
import Navbar from "../layouts/Navbar";
import ImageCropper from "../crop_image/ImageCropper";
import Swal from "sweetalert2";

function GaleriEdit() {
    const { id_galeri } = useParams();
    const navigate = useNavigate();

    const [formValue, setFormValue] = useState({
        title_foto_satu: "",
        title_foto_dua: "",
        title_foto_tiga: "",
        foto_satu: "",
        foto_dua: "",
        foto_tiga: "",
        id_group: "",
        tanggal: "",
    });

    const [selectedFiles, setSelectedFiles] = useState({
        foto_satu: null,
        foto_dua: null,
        foto_tiga: null,
    });

    const [preview, setPreview] = useState({
        foto_satu: null,
        foto_dua: null,
        foto_tiga: null,
    });

    const [cropData, setCropData] = useState({
        isOpen: false,
        imageSrc: null,
        imageType: "",
    });

    const [croppedImage, setCroppedImage] = useState(null);

    const [groups, setGroups] = useState([]);

    const fetchGroups = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/galeryGroup/readGaleriGroup`);
            setGroups(response.data);
        } catch (error) {
            console.error("Error fetching groups:", error);
        }
    };

    const fetchData = useCallback(async () => {
        try {
            const token = localStorage.getItem("token");
            if (!token) {
                navigate("/");
                return;
            }

            // Set token in axios headers
            axios.interceptors.request.use(
                (config) => {
                    config.headers.authorization = token;
                    return config;
                },
                (error) => {
                    return Promise.reject(error);
                }
            );
            const response = await axios.get(
                `${process.env.REACT_APP_API_URL}/galery/readGaleriById/${id_galeri}`
            );
            const data = response.data;
            setFormValue({
                title_foto_satu: data.title_foto_satu,
                title_foto_dua: data.title_foto_dua,
                title_foto_tiga: data.title_foto_tiga,
                foto_satu: data.foto_satu,
                foto_dua: data.foto_dua,
                foto_tiga: data.foto_tiga,
                id_group: data.id_group,
                tanggal: data.tanggal.split("T")[0],
            });
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    }, [id_galeri]);

    useEffect(() => {
        fetchData();
        fetchGroups();
    }, [fetchData]);

    const openCropper = (file, imageType) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            setCropData({
                isOpen: true,
                imageSrc: reader.result,
                imageType,
            });
        };
    };

    const closeCropper = () => {
        setCropData({
            isOpen: false,
            imageSrc: null,
            imageType: "",
        });
        setCroppedImage(null);
    };

    const applyCrop = () => {
        if (croppedImage instanceof Blob) {
            const blobUrl = URL.createObjectURL(croppedImage);
            setSelectedFiles({
                ...selectedFiles,
                [cropData.imageType]: croppedImage,
            });
            setPreview({
                ...preview,
                [cropData.imageType]: blobUrl,
            });
        } else {
            console.error("Cropped image is not a Blob:", croppedImage);
        }
        closeCropper();
    };

    const handleChange = (event) => {
        const { name, value, files } = event.target;
        if (files && files.length > 0) {
            const file = files[0];
            openCropper(file, name);
        } else {
            setFormValue({
                ...formValue,
                [name]: value,
            });
            if (name.startsWith("foto_")) {
                setPreview({
                    ...preview,
                    [name]: null,
                });
            }
        }
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (
            !formValue.title_foto_satu ||
            !formValue.title_foto_dua ||
            !formValue.title_foto_tiga ||
            !formValue.id_group
        ) {
            Swal.fire({
                title: "Error",
                text: "Semua field harus diisi",
                icon: "error",
            });
            return;
        }

        const FormDataInput = new FormData();
        if (selectedFiles.foto_satu) {
            FormDataInput.append("foto_satu", selectedFiles.foto_satu);
        }
        if (selectedFiles.foto_dua) {
            FormDataInput.append("foto_dua", selectedFiles.foto_dua);
        }
        if (selectedFiles.foto_tiga) {
            FormDataInput.append("foto_tiga", selectedFiles.foto_tiga);
        }
        FormDataInput.append("title_foto_satu", formValue.title_foto_satu);
        FormDataInput.append("title_foto_dua", formValue.title_foto_dua);
        FormDataInput.append("title_foto_tiga", formValue.title_foto_tiga);
        FormDataInput.append("id_group", formValue.id_group);
        FormDataInput.append("tanggal", formValue.tanggal);

        try {
            const response = await axios.put(
                `${process.env.REACT_APP_API_URL}/galery/updateGaleri/${id_galeri}`,
                FormDataInput,
                { headers: { "Content-Type": "multipart/form-data" } }
            );

            Swal.fire({
                title: "Success",
                text: "Data berhasil diperbarui",
                icon: "success",
            });
            navigate("/galeri");
        } catch (error) {
            console.error("Error updating data:", error);
            Swal.fire({
                title: "Error",
                text: "Data gagal diperbarui",
                icon: "error",
            });
        }
    };

    return (
        <div className="wrapper">
            <Header />
            <Navbar />
            <div className="content-wrapper">
                <section className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1>Administrasi</h1>
                            </div>
                            <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item text-decoration-none">
                                        <Link className="text-decoration-none" to="/">
                                            Administrasi
                                        </Link>
                                    </li>
                                    <li className="breadcrumb-item active">Galeri</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="content galeri-edit">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-header">
                                        <h3 className="card-title">Edit Galeri</h3>
                                    </div>
                                    <div className="card-body">
                                        <form onSubmit={handleSubmit}>
                                            <div className="card-body">
                                                <div className="form-group">
                                                    <label>Group</label>
                                                    <select
                                                        className="form-control"
                                                        name="id_group"
                                                        onChange={handleChange}
                                                        value={formValue.id_group}
                                                    >
                                                        <option value="">Pilih Group</option>
                                                        {groups.map((group) => (
                                                            <option
                                                                key={group.id_group}
                                                                value={group.id_group}
                                                            >
                                                                {group.group_galeri}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div className="form-group">
                                                    <label>Title Foto 1</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="title_foto_satu"
                                                        placeholder="Masukkan Title Foto 1"
                                                        onChange={handleChange}
                                                        value={formValue.title_foto_satu}
                                                    />
                                                </div>
                                                <div className="form-group galeri-edit-foto">
                                                    <label>Foto 1</label>
                                                    <input
                                                        type="file"
                                                        className="form-control"
                                                        name="foto_satu"
                                                        accept="image/*"
                                                        placeholder="Masukkan foto 1"
                                                        onChange={handleChange}
                                                    />
                                                    {formValue.foto_satu && (
                                                        <div className="preview-container-galery">
                                                            <img
                                                                src={
                                                                    preview.foto_satu ||
                                                                    formValue.foto_satu
                                                                }
                                                                alt="Preview"
                                                                className="preview-image-galery"
                                                            />
                                                        </div>
                                                    )}
                                                </div>
                                                <div className="form-group">
                                                    <label>Title Foto 2</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="title_foto_dua"
                                                        placeholder="Masukkan Title Foto 2"
                                                        onChange={handleChange}
                                                        value={formValue.title_foto_dua}
                                                    />
                                                </div>
                                                <div className="form-group galeri-edit-foto">
                                                    <label>Foto 2</label>
                                                    <input
                                                        type="file"
                                                        className="form-control"
                                                        name="foto_dua"
                                                        accept="image/*"
                                                        placeholder="Masukkan foto 2"
                                                        onChange={handleChange}
                                                    />
                                                    {formValue.foto_dua && (
                                                        <div className="preview-container-galery">
                                                            <img
                                                                src={
                                                                    preview.foto_dua ||
                                                                    formValue.foto_dua
                                                                }
                                                                alt="Preview"
                                                                className="preview-image-galery"
                                                            />
                                                        </div>
                                                    )}
                                                </div>
                                                <div className="form-group">
                                                    <label>Title Foto 3</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="title_foto_tiga"
                                                        placeholder="Masukkan Title Foto 3"
                                                        onChange={handleChange}
                                                        value={formValue.title_foto_tiga}
                                                    />
                                                </div>
                                                <div className="form-group galeri-edit-foto">
                                                    <label>Foto 3</label>
                                                    <input
                                                        type="file"
                                                        className="form-control"
                                                        name="foto_tiga"
                                                        accept="image/*"
                                                        placeholder="Masukkan foto 3"
                                                        onChange={handleChange}
                                                    />
                                                    {formValue.foto_tiga && (
                                                        <div className="preview-container-galery">
                                                            <img
                                                                src={
                                                                    preview.foto_tiga ||
                                                                    formValue.foto_tiga
                                                                }
                                                                alt="Preview"
                                                                className="preview-image-galery"
                                                            />
                                                        </div>
                                                    )}
                                                </div>
                                                <div>
                                                    <button type="submit" className="btn btn-info">
                                                        Simpan
                                                    </button>
                                                    <Link to="/galeri">
                                                        <button
                                                            type="button"
                                                            className="btn btn-secondary ml-2"
                                                        >
                                                            Batal
                                                        </button>
                                                    </Link>
                                                </div>
                                            </div>
                                        </form>
                                        {cropData.isOpen && (
                                            <ImageCropper
                                                imageSrc={cropData.imageSrc}
                                                setCroppedImage={setCroppedImage}
                                                onCropComplete={applyCrop}
                                                onClose={closeCropper}
                                            />
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
}

export default GaleriEdit;
